






































import { defineComponent, reactive } from '@vue/composition-api'
import NameCard from '@/components/cards/NameCard.vue'
import IntroductionCard from '@/components/cards/IntroductionCard.vue'
import CareerCard from '@/components/cards/CareerCard.vue'
import CarouselCard from '@/components/cards/CarouselCard.vue'
import ImageModal from '@/components/modals/ImageModal.vue'
import ProfileComponent from '@/modules/local/profile'
import LoadingCircle from '@/components/LoadingCircle.vue'
export default defineComponent({
  components: {
    NameCard,
    CareerCard,
    IntroductionCard,
    CarouselCard,
    ImageModal,
    LoadingCircle
  },
  setup(_, ctx) {
    const profileComponent = ProfileComponent(ctx)
    profileComponent.get()
    const state = reactive({ showSkillModal: false })
    return {
      state,
      ...profileComponent,
      openSkill(pos: number) {
        profileComponent.setSkill(pos)
        state.showSkillModal = true
      },
      jumpLink(pos: number) {
        profileComponent.navigateToSns(pos)
      }
    }
  }
})
